<script setup>
import { useAppLayout } from '@/use'

defineProps({
  logoImage: { type: String, default: '' },
})

const appLayout = useAppLayout()
const { layoutState } = appLayout

const adminLinks = [
  {
    group: 'People',
    icon: 'ph ph-user-list',
    links: [
      { label: 'Web Users',              route: '/admin/users',            isActive: true  },
      { label: 'Destination Guides',     route: '/admin/guides',           isActive: true  },
      { label: 'Destination Counselors', route: '/admin/counselors',       isActive: true  },
      { label: 'Escrow Officers',        route: '/admin/escrow-officers',  isActive: true  },
      { label: 'Lender Contacts',        route: '/admin/lender-contacts',  isActive: true  },
      { label: 'Realtors',               route: '/admin/realtors',         isActive: true  },
      { label: 'Relo Consultants',       route: '/admin/relo-consultants', isActive: true  },
      { label: 'HR Contacts',            route: '/admin/hr-contacts',      isActive: true  },
    ],
  },
  {
    group: 'Organizations',
    icon: 'ph ph-buildings',
    links: [
      { label: 'Corporate Clients', routeName: 'companiesIndex',      isActive: true  },
      { label: 'Relo Companies',    routeName: 'reloCompaniesIndex',  isActive: true  },
      { label: 'Lenders',           route: '/admin/lenders',          isActive: true  },
      // { label: 'Hotels',                                                   isActive: false },
    ],
  },
  // {
  //   group: 'Admin',
  //   icon: 'ph ph-database',
  //   links: [
  //     { label: 'Tour Types',                                                isActive: false },
  //     { label: 'Areas',                                                     isActive: false },
  //     { label: 'Area Zones',                                                isActive: false },
  //   ],
  // },
  // {
  //   group: 'Miscellaneous',
  //   icon: 'ph ph-circle',
  //   links: [
  //     { label: 'Services',                                                  isActive: false },
  //   ],
  // },
]
</script>

<template lang="pug">
Drawer(v-model:visible="layoutState.showAdminDrawer" header="Manage" position="left")
  template(#header)
    .flex.items-center.gap-4
      img.logo-image(:src="logoImage" width="40px" height="40px")
      .text-normal.text-canvas-400.font-bold Manage

  .ml-2
    ul.admin-link-list.my-4(v-for="{group, icon, links} in adminLinks" :key="group")
      li.admin-group-label.font-bold.text-canvas-500.pb-3 {{ group }}
      li.flex.font-semibold(
        v-for="link in links"
        :key="link.label"
        :class="link.isActive ? 'text-accent' : 'text-canvas-400'"
      )
        RouterLink.admin-link(
          v-if="link.route || link.routeName"
          :to="link.routeName ? { name: link.routeName } : link.route"
          @click="appLayout.toggleAdminDrawer"
        )
          span.mr-2: i(:class="icon")
          span {{ link.label }}
        a.admin-link(v-else href="#")
          span.mr-2: i(:class="icon")
          span {{ link.label }}
</template>
